<script setup>
import { onMounted, ref } from 'vue';
import AOS from 'aos';
import { Icon } from '@iconify/vue';

const policies = ref([
  { nameKey: 'policyLinks.links[0].name', routeName: 'FinancialManagementPolicy' },
  { nameKey: 'policyLinks.links[1].name', routeName: 'AssetAndInventoryManagementPolicy' },
  { nameKey: 'policyLinks.links[2].name', routeName: 'confidentialityAndDataProtectionPolicy' },
  { nameKey: 'policyLinks.links[3].name', routeName: 'EnvironmentalManagementPolicy' },
  { nameKey: 'policyLinks.links[4].name', routeName: 'moniteringPolicy' },
  { nameKey: 'policyLinks.links[5].name', routeName: 'HRPolicy' },
  { nameKey: 'policyLinks.links[6].name', routeName: 'PartnershipPolicy' },
  { nameKey: 'policyLinks.links[7].name', routeName: 'GovernancePolicy' },
  { nameKey: 'policyLinks.links[8].name', routeName: 'ProgrammaticAccountabilityPolicy' },
  { nameKey: 'policyLinks.links[9].name', routeName: 'RiskManagementPolicy' },
  { nameKey: 'policyLinks.links[10].name', routeName: 'ProcurementManagementPolicy' },
]);

onMounted(() => {
  AOS.init({
    duration: 800,
    once: true,
  });
});
</script>

<template>
  <div class="page-wrapper">
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <h1 class="title" data-aos="fade-up">{{ $t('policyLinks.title') }}</h1>
    </div>
    <section class="main-content">
      <div class="policies-grid">
        <router-link
          v-for="(policy, index) in policies"
          :key="policy.routeName"
          :to="{ name: policy.routeName }"
          class="policy-card"
          data-aos="fade-up"
          :data-aos-delay="index * 50"
        >
          <Icon icon="solar:document-text-linear" class="card-icon" />
          <span class="card-title">{{ $t(policy.nameKey) }}</span>
          <Icon icon="solar:arrow-right-linear" class="arrow-icon" />
        </router-link>
      </div>
    </section>
  </div>
</template>

<style  scoped>
.hero-section {
  background-image: url("../assets/rectangle-31@2x.webp");
  background-position: center center;
  background-size: cover;
  height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  text-align: center;
}
.hero-overlay {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background-color: rgba(10, 45, 97, 0.6);
}
.title {
  font-size: 3rem;
  color: white;
  text-transform: uppercase;
  position: relative;
  z-index: 2;
  padding-bottom: 0.5rem;
}
.title::after {
  content: "";
  position: absolute;
  background: #fcbc0d;
  width: 80px;
  height: 4px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
}

.main-content {
  padding: 6rem 5%;
  background-color: #f8f9fa;
}

.policies-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.policy-card {
  display: flex;
  align-items: center;
  gap: 1rem;
  background: #fff;
  padding: 1.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 25px rgba(0, 0, 0, 0.07);
  text-decoration: none;
  color: #333;
  transition: transform 0.3s ease, box-shadow 0.3s ease, color 0.3s ease;
}

.policy-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 8px 35px rgba(0, 0, 0, 0.1);
  color: #0A2D61;
}

.card-icon {
  font-size: 1.8rem;
  color: #0A2D61;
  flex-shrink: 0;
}

.card-title {
  flex-grow: 1;
  font-weight: 600;
  text-align: left;
  text-transform: capitalize;
}

.arrow-icon {
  font-size: 1.5rem;
  opacity: 0.5;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.policy-card:hover .arrow-icon {
  transform: translateX(5px);
  opacity: 1;
}

@media (max-width: 768px) {
  .title {
    font-size: 2.2rem;
  }
  .policies-grid {
    grid-template-columns: 1fr;
  }
}
</style>